import React from "react";

type SvgProps = React.SVGProps<SVGSVGElement>;

export const Mail = (props: SvgProps) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6103_73770)">
      <path
        d="M16 2.66675H4C3.46957 2.66675 2.96086 2.87746 2.58579 3.25253C2.21071 3.62761 2 4.13631 2 4.66675L2 17.3334H18V4.66675C18 4.13631 17.7893 3.62761 17.4142 3.25253C17.0391 2.87746 16.5304 2.66675 16 2.66675V2.66675ZM4 4.00008H16C16.1768 4.00008 16.3464 4.07032 16.4714 4.19534C16.5964 4.32037 16.6667 4.48994 16.6667 4.66675V5.11141L11.4147 10.3641C11.039 10.7383 10.5303 10.9484 10 10.9484C9.46972 10.9484 8.96105 10.7383 8.58533 10.3641L3.33333 5.11141V4.66675C3.33333 4.48994 3.40357 4.32037 3.5286 4.19534C3.65362 4.07032 3.82319 4.00008 4 4.00008V4.00008ZM3.33333 16.0001V7.00008L7.64267 11.3067C8.26842 11.9309 9.11617 12.2814 10 12.2814C10.8838 12.2814 11.7316 11.9309 12.3573 11.3067L16.6667 7.00008V16.0001H3.33333Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6103_73770">
        <rect width="16" height="16" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);
